module.exports = __webpack_public_path__ + "img/decepcionada.95086d71.png";